import { Component, ElementRef, Input, OnInit, ViewChild, ViewChildren, OnDestroy } from '@angular/core';
import { AbstractControl, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { TransferStaffAou } from '@ascschool/model/transfer/transfer-staff-aou.model';
import { DistrictService } from '@ascschool/services/category/district.service';
import { ProvinceService } from '@ascschool/services/category/province.service';
import { SchoolService } from '@ascschool/services/organization/school.service';
import { TransferStaffService } from '@ascschool/services/transfer/transferstaff.service';
import { UtilsService } from '@ascschool/services/utils.service';
import { NzMessageService } from 'ng-zorro-antd/message';
import { NzModalRef, NzModalService } from 'ng-zorro-antd/modal';
import { Observable,Subject } from 'rxjs';
import { map, takeUntil} from 'rxjs/operators';
import { NhanSuCuaCsComponent } from './nhan-su-cua-cs/nhan-su-cua-cs.component';

@Component({
  selector: 'chuyen-nhan-su-aou',
  templateUrl: './chuyen-nhan-su-aou.component.html',
  styleUrls: ['./chuyen-nhan-su-aou.component.scss']
})
export class ChuyenNhanSuAouComponent implements OnInit {
  @ViewChildren("label") labelElement: ElementRef;
  @Input() value: any;
  $unSubcribe = new Subject();
  isResizdePopup: boolean;
  dialogRef: NzModalRef;
  isEditMode = false;
  transferStaff = new TransferStaffAou();
  errorMsg: string;
  isDisabled = false;
  currentUser : any;
  validateForm = new FormGroup({
    id: new FormControl(0),
    staffId: new FormControl(null, Validators.required),
    staffCode: new FormControl(null),
    fullName: new FormControl(null),
    provinceId: new FormControl(null),
    districtId: new FormControl(null),
    transferToEatosId: new FormControl(null),
    transferDate: new FormControl(null, Validators.required),
    effectiveDate: new FormControl(null, Validators.required),
    transferReason: new FormControl(null),
    decisionNumber: new FormControl(null)
  });

  staffCodeControl = this.validateForm.controls.staffCode;
  staffNameControl = this.validateForm.controls.fullName;

  provinceControl = this.validateForm.controls.provinceId;
  districtControl = this.validateForm.controls.districtId;

  transferToEatosIdControl = this.validateForm.controls.transferToEatosId;
  transferTransferDateControl = this.validateForm.controls.transferDate;
  transferTransferReasonControl = this.validateForm.controls.transferReason;

  getProvinceACFn: (value: any) => Observable<any>;
  getDistrictACFn: (value: any) => Observable<any>;
  getTransferToEatosACFn: (value: any) => Observable<any>;
  constructor(
    private modal: NzModalRef, private msg: NzMessageService, public utilsService: UtilsService,
    private service: TransferStaffService, private fb: FormBuilder, private provinceService: ProvinceService,
    private districtService: DistrictService, private schoolService: SchoolService, private modalService: NzModalService
  ) {
  }

  ngOnInit() {
    // this.transferStaff.gender  = this.value.gender == 0 ? 'Nữ' : 'Nam';
    this.currentUser = JSON.parse(localStorage.getItem('userSetting'));

    if (this.value && this.value.id > 0) {
      this.GetById(this.value.id);
      this.isEditMode = true;
      this.transferStaff.id = this.value.id;
    }

    this.loadProvince();

  }

  public chooseStu(data: any): void {
  }

  dateFormat = 'dd/MM/yyyy';
  GetById(id: number) {
    this.service.getTransferStaffById(id).subscribe((res: any) => {
      this.transferStaff = res;
    });
  }

  changStaffCode(): void {
    if (this.staffCodeControl && this.staffCodeControl.value && this.staffCodeControl.value.length === 12) {
      this.service.getStaByCode(this.staffCodeControl.value).subscribe((res: any) => {
        this.transferStaff.staffId = res.staffId;
        this.transferStaff.fullName = res.fullName;
        this.transferStaff.gender = res.gender;
        this.transferStaff.yearOfBirth = res.yearOfBirth;
        this.transferStaff.typeOfPersonnelName = res.typeOfPersonnelName;
        this.transferStaff.positionName = res.positionName;
        this.transferStaff.positionGVName = res.positionGVName;
        if (res.staffId === 0) {
          if (res.waiting === 1) {
            this.msg.error('Người khuyết tật có mã ' + this.staffCodeControl.value + 'đã chuyển cơ sở và đang chờ tiếp nhận');
          } else {
            this.msg.error('Không tìm thấy nhân sự thuộc đợn vị của bạn có mã: ' + this.staffCodeControl.value);
          }
        }
      });
    } else {
      this.transferStaff.staffId = 0;
      this.transferStaff.fullName = this.transferStaff.gender = this.transferStaff.yearOfBirth
        = this.transferStaff.typeOfPersonnelName = this.transferStaff.positionName = '';
    }
  }
  changStaffName(): void {
    if (this.staffNameControl && this.staffNameControl.value && this.staffNameControl.value.length === 12) {
      this.service.getStaByCode(this.staffNameControl.value).subscribe((res: any) => {
        this.transferStaff.staffId = res.staffId;
        this.transferStaff.staffCode = res.staffCode;
        this.transferStaff.gender = res.gender;
        this.transferStaff.yearOfBirth = res.yearOfBirth;
        this.transferStaff.typeOfPersonnelName = res.typeOfPersonnelName;
        this.transferStaff.positionName = res.positionName;
        this.transferStaff.positionGVName = res.positionGVName;
        if (res.staffId === 0) {
          if (res.waiting === 1) {
            this.msg.error('Người khuyết tật có mã ' + this.staffNameControl.value + 'đã chuyển cơ sở và đang chờ tiếp nhận');
          } else {
            this.msg.error('Không tìm thấy nhân sự thuộc đợn vị của bạn có mã: ' + this.staffNameControl.value);
          }
        }
      });
    } else {
      this.transferStaff.staffId = 0;
      this.transferStaff.fullName = this.transferStaff.gender = this.transferStaff.yearOfBirth
        = this.transferStaff.typeOfPersonnelName = this.transferStaff.positionName = '';
    }
  }
  loadProvince(reset = true) {
    this.getProvinceACFn = (value: any) => this.provinceService.getProvinceSelectPaging({
      searchTerm: value, PageIndex: 1, PageSize: 100
    }).pipe(map(resp => resp.results.length > 0
      ? resp.results.map(x => ({ id: x.id, text: x.provinceName })) : [{ id: null, text: 'Không có dữ liệu' }]));
    if (reset) this.provinceControl.setValue(null);
  }

  changeProvince(control: FormControl) {
    this.provinceControl = control;
    this.transferStaff.provinceId = this.provinceControl.value;
    this.loadDistrict();
    this.districtControl.setValue(null);
  }

  loadDistrict(reset = true) {
    this.getDistrictACFn = (value: any) => this.districtService.getDistrictSelectPaging({
      searchTerm: value, ProvinceId: this.valueIfHas(this.provinceControl), PageIndex: 1, PageSize: 100
    }).pipe(map(resp => resp.results.length > 0
      ? resp.results.map(x => ({ id: x.id, text: x.districtName })) : [{ id: null, text: 'Không có dữ liệu' }]));
    if (reset) this.districtControl.setValue(null);
  }

  changeDistrict(control: FormControl) {
    this.districtControl = control;
    this.loadTransferToEatos();
    this.transferToEatosIdControl.setValue(null);
  }

  loadTransferToEatos(reset = true) {
    this.getTransferToEatosACFn = (value: any) => this.service.getEatos({
      searchTerm: value, ProvinceId: this.valueIfHas(this.provinceControl), DistrictId: this.valueIfHas(this.districtControl), PageIndex: 1, PageSize: 100
    }).pipe(map(resp => resp.results.length > 0
      ? resp.results.map(x => ({ id: x.id, text: x.educationAndTrainingName })) : [{ id: null, text: 'Không có dữ liệu' }]));
    if (reset) this.transferToEatosIdControl.setValue(null);
  }

  changeTransferToEatos(control: FormControl) {
    this.transferToEatosIdControl = control;
  }

  valueIfHas(control: AbstractControl) {
    if (control.value && typeof control.value != 'string') return control.value.id;
    return '';
  }

  close() {
    this.destroyModal();
  }

  destroyModal(): void {
    this.modal.destroy(true);
  }

  UpdateClose() {
    if(!this.validateForm.get('transferToEatosId').value){
        this.validateForm.get('transferToEatosId').setValue(0);
    }
    this.validateForm.controls.staffId.setValue(this.transferStaff.staffId)
    if (this.validateForm.valid) {
      this.service.addOrUpdatetransferStaff(this.bindOfDataId(this.validateForm)).subscribe((res) => {
        if (res.statusCode === 0) {
          this.notification(res);
          this.close();
        } else {
          this.notification(res);
        }
      }, error => {
        this.msg.error(error.error.Message);
      });
    } else {
      this.utilsService.showNotifyInvalidControls(this.validateForm, this.labelElement);
    }
  }
  bindOfDataId(formGroup: FormGroup) {
    let data;
    data = formGroup.value;
    const controls = formGroup.controls;
    for (const name in controls) {
      if (data[name] && data[name].id) {
        data[name] = data[name].id
      }
    }
    return data;
  }
  notification(response) {
    if (response.statusCode === 0) {
      this.msg.success('Cập nhật thông tin: ' + response.message);
    } else {
      this.msg.error('Lỗi: ' + response.message);
    }
  }

  PopupChooseStu(): void {
    this.isResizdePopup = false;
    this.dialogRef = this.modalService.create({
      nzTitle: "Tìm kiếm nhân sự",
      nzContent: NhanSuCuaCsComponent,
      nzStyle: { top: '30px' },
      nzMaskClosable: true,
      nzBodyStyle: {
        overflow: 'auto',
        maxheight: this.caculateHeightPopup(window.innerHeight) + 'px',
        height: this.caculateHeightPopup(window.innerHeight) + 'px',
      },
      nzWidth: 1500
    });

    this.dialogRef.afterClose.subscribe(res => {
      if (res) {
        this.staffCodeControl.setValue(res.staffCode);
        this.transferStaff.staffCode = res.staffCode;
        this.transferStaff.staffId = res.staffId;
        this.transferStaff.fullName = res.fullName;
        this.transferStaff.gender = res.gender == 1 ? 'Nam' : res.gender == 0 ? 'Nữ' : '';
        this.transferStaff.yearOfBirth = res.yearOfBirth;
        this.transferStaff.typeOfPersonnelName = res.typeOfPersonnelName;
        this.transferStaff.positionName = res.positionName;

      }
    });
  }

  caculateHeightPopup(maxHeight: number): number {
    let heightModal: number;
    if (maxHeight > 950) {
      return (heightModal = 700 + (maxHeight - 860));

    } else {
      return (heightModal = 700 - (860 - maxHeight));
    }
  }
}
